<template>
    <v-content>
        <v-container fluid fill-height>
            <v-layout align-center justify-center>
                <v-flex xs12 sm8 md4>
                    <v-card class="elevation-12">
                        <v-card-title>Login</v-card-title>
                        <v-card-text>
                            <v-form>
                                <v-text-field
                                    id="email"
                                    label="Email"
                                    name="email"
                                    prepend-icon="mdi-account"
                                    type="text"
                                    v-model="email"
                                    required
                                ></v-text-field>

                                <v-text-field
                                    id="password"
                                    label="Password"
                                    name="password"
                                    prepend-icon="mdi-lock"
                                    type="password"
                                    v-model="password"
                                    required
                                ></v-text-field>
                            </v-form>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" type="submit" @click="handleSubmit">Login</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </v-content>
</template>

<script>
export default {
    data() {
        return {
            email: "",
            password: ""
        }
    },
    methods: {
        handleSubmit(e) {
            e.preventDefault()
            if (this.password.length > 0) {
                this.$http
                    .post(process.env.VUE_APP_API_URL + "/usuarios/login", {
                        email: this.email,
                        password: this.password
                    })
                    .then(response => {
                        localStorage.setItem("usuario", JSON.stringify(response.data.usuario))
                        localStorage.setItem("jwt", response.data.token)
                        this.$store.commit("login")

                        if (localStorage.getItem("jwt") != null) {
                            this.$emit("loggedIn")
                            if (this.$route.params.nextUrl != null) {
                                this.$router.push(this.$route.params.nextUrl)
                            } else {
                                this.$router.push("/home")
                            }
                        }
                    })
                    .catch(function(error) {
                        console.error(error.response)
                    })
            }
        }
    }
}
</script>
